import { useState } from "react";
import { Send, Check } from "lucide-react";
import { useLanguage } from "./LanguageContext";
import { useAdminData } from "./admin/AdminDataContext";
import { useTheme } from "./ThemeInjector";

export function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const { t } = useLanguage();
  const { siteConfig } = useAdminData();
  const theme = useTheme();

  if (!siteConfig.features?.newsletter) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
    setEmail("");
  };

  return (
    <section className="py-24" style={{ backgroundColor: theme.fg }}>
      <div className="max-w-2xl mx-auto px-6 text-center">
        <p
          className="text-[#C7A76C] tracking-[0.3em] uppercase mb-4"
          style={{ fontFamily: theme.fontBody, fontSize: "12px", color: theme.accent }}
        >
          {t("newsletter.label")}
        </p>
        <h2
          className="text-white tracking-[0.1em] mb-4"
          style={{ fontFamily: theme.fontHeading, fontSize: "clamp(28px, 4vw, 40px)", fontWeight: 400 }}
        >
          {t("newsletter.title")}
        </h2>
        <p
          className="text-white/60 leading-[1.8] mb-10 max-w-lg mx-auto"
          style={{ fontFamily: theme.fontBody, fontSize: "15px", fontWeight: 300 }}
        >
          {t("newsletter.desc")}
        </p>

        {submitted ? (
          <div className="flex items-center justify-center gap-3">
            <div className="w-8 h-8 rounded-full bg-[#6F7F63] flex items-center justify-center">
              <Check size={16} className="text-white" />
            </div>
            <p
              className="text-white/80"
              style={{ fontFamily: theme.fontBody, fontSize: "15px", fontWeight: 300 }}
            >
              {t("newsletter.success")}
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex gap-3 max-w-md mx-auto">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("newsletter.placeholder")}
              className="flex-1 px-5 py-3 bg-white/10 border border-white/15 rounded-lg text-white placeholder:text-white/30 focus:outline-none focus:border-[#C7A76C] transition-colors"
              style={{ fontFamily: theme.fontBody, fontSize: "14px", fontWeight: 300 }}
              aria-label={t("newsletter.placeholder")}
            />
            <button
              type="submit"
              className="px-6 py-3 text-white transition-colors flex items-center gap-2 tracking-[0.15em] uppercase focus:outline-none focus:ring-2 focus:ring-offset-2"
              style={{ fontFamily: theme.fontBody, fontSize: "11px", fontWeight: 400, backgroundColor: theme.accent, borderRadius: theme.btnRadius }}
            >
              <Send size={14} />
              {t("newsletter.subscribe")}
            </button>
          </form>
        )}

        <p
          className="text-white/25 mt-6"
          style={{ fontFamily: theme.fontBody, fontSize: "11px", fontWeight: 300 }}
        >
          {t("newsletter.privacy")}
        </p>
      </div>
    </section>
  );
}